<template>
  <div class="today-comment-module" v-if="tabsMenuLength !== null">
    <div class="tabs-header">
      <!-- <p :class="activeTabs == 0 ? 'activeTabs':''" @click="changeTabs(0)">每日一省</p>
            <p :class="activeTabs == 1 ? 'activeTabs':''" @click="changeTabs(1)">热门帖子</p>
            <p :class="activeTabs == 2 ? 'activeTabs':''" @click="changeTabs(2)">最新帖子</p> -->
      <p
        v-for="(li, index) in showModule"
        :key="index"
        :class="`${activeTabs == index ? 'activeTabs' : ''} ${
          li.is_checked == 1 ? '' : 'hide-tabs'
        }`"
        @click="changeTabs(index)"
      >
        <span :class="tabsMenuLength == 1 ? 'module-title' : ''">{{
          $i18n.locale == "zh" ? li.name : li.name_en
        }}</span>
      </p>
    </div>
    <div class="tabs-body">
      <div v-for="(li, index) in showModule" :key="index">
        <transition-group
          :enter-active-class="animateClass"
          tag="div"
          :leave-active-class="animateLeave"
        >
          <everyday-answer
            v-if="
              activeTabs == index && li.is_checked && li.tag == 'dailyReflect'
            "
            :key="index"
          ></everyday-answer>
          <host-post
            v-else-if="activeTabs == index && li.is_checked && li.tag == 'hot'"
            :key="index"
          ></host-post>
          <new-post
            v-else-if="activeTabs == index && li.is_checked && li.tag == 'new'"
            :key="index"
          ></new-post>
        </transition-group>
      </div>
    </div>
  </div>
</template>
<script>
// 每日一省
import everydayAnswer from "./component/everydayAnswer";
// 热门帖子
import hostPost from "./component/hostPost";
// 最新帖子
import newPost from "./component/newPost";

export default {
  props: ["showModule"],
  data() {
    return {
      // 当前激活菜单
      activeTabs: 0,
      tabsMenuLength: null,
      // 切换动画
      animateClass: "animated fadeInUpBig",
      animateLeave: "animated fadeOutDownBig",
    };
  },
  created() {
    this.showModule.map((li) => {
      if (li.is_checked === 1) this.tabsMenuLength = this.tabsMenuLength + 1;
    });
    for (let li in this.showModule) {
      if (this.showModule[li].is_checked === 1) {
        this.activeTabs = li;
        return;
      }
    }
  },
  methods: {
    // 切换标签
    changeTabs(num) {
      if (this.activeTabs < num) {
        this.animateLeave = "animated fadeOutLeft";
        this.animateClass = "animated fadeInRight";
      } else {
        this.animateLeave = "animated fadeOutRight";
        this.animateClass = "animated fadeInLeft";
      }
      this.activeTabs = num;
    },
    // 查看全部
    lookAllComment() {
      if (this.showModule[this.activeTabs].tag === "dailyReflect") {
        this.$router.push({ path: "/main/365allAnswer" });
      } else if (this.showModule[this.activeTabs].tag === "hot") {
        this.$router.push({ path: "/main/365allPost", query: { type: "hot" } });
      } else {
        this.$router.push({ path: "/main/365allPost", query: { type: "new" } });
      }
    },
  },
  components: {
    everydayAnswer,
    hostPost,
    newPost,
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/sass/color.less";

.animated {
  animation-duration: 0.3s;
  width: 100%;
}
.fadeInRight,
.fadeInLeft {
  position: absolute;
  top: 0;
}
.today-comment-module {
  overflow-x: hidden;
  background: white;
  margin-bottom: 0.2rem;
  .tabs-header {
    display: flex;
    font-size: 0.3rem;
    p {
      flex: 1;
      text-align: center;
      line-height: 0.8rem;
      background: #f6f6f6;
    }
    p:nth-child(2) {
      border-left: 0.02rem solid #ddd;
      border-right: 0.02rem solid #ddd;
    }
    .activeTabs {
      color: @mColor;
      background: white;
    }
    .hide-tabs {
      display: none;
    }
    .module-title {
      color: #333;
      border-bottom: 0.02rem solid #f6f6f6;
      display: flex;
      align-items: center;
      justify-content: center;
      &::before {
        content: "";
        margin-right: 0.03rem;
        background: #999;
        width: 0.22rem;
        height: 0.02rem;
        margin-right: 0.08rem;
      }
      &::after {
        content: "";
        margin-right: 0.03rem;
        background: #999;
        width: 0.22rem;
        height: 0.02rem;
        margin-left: 0.08rem;
      }
    }
  }
  .tabs-body {
    position: relative;
    min-height: 1rem;
    overflow: hidden;
  }
}
</style>
